import { Link, useParams } from "react-router-dom";
import { useI18n } from "../i18n/index.js";
import styles from "./GamePlaceholder.module.css";

/**
 * Temporary route target for games not yet implemented (Timeslip lands in
 * M3, Crowflight in M5, Huesswork in M6). Replaced per-game as each module
 * is built, per spec §5 (new game = new module + registry entry).
 */
export function GamePlaceholder() {
  const { t } = useI18n();
  const { gameId } = useParams();

  return (
    <main className={styles.main}>
      <h1>{gameId}</h1>
      <p>Kommt in einem der nächsten Meilensteine. / Coming in an upcoming milestone.</p>
      <Link to="/">{t("common.backHome")}</Link>
    </main>
  );
}
